import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import App from '../containers/layout/app';
import UsersPage from './Users/UsersPage';
import SettingsPage from './Settings/SettingsPage';
import Channels from './Channels';
import AppHomePage from './AppHome/AppHomePage';
import AppDashboardPage from './AppDashboard/AppDashboardPage';
import authStorage from '../storages/mobx/authStorage';
import { MENUITEMS } from '../containers/layout/sidebar-component/menu';

function Dashboard() {
  const getPermission = (path) => {
    const currentItem = MENUITEMS.find((item) => item.path === path);
    const currentRoles = currentItem?.roles;
    return currentRoles ? authStorage.itemHasRole(currentRoles) : false;
  };
  return (
    <App className={authStorage.isLogged ? 'logged' : 'not-logged'}>
      <Route path="/app" exact component={AppHomePage} />
      <Route path="/app/dashboard" component={getPermission('/app/dashboard') ? AppDashboardPage : () => <Redirect to="/app" />} />
      <Route path="/app/users" component={getPermission('/app/users') ? UsersPage : () => <Redirect to="/app" />} />
      <Route path="/app/settings" component={getPermission('/app/settings') ? SettingsPage : () => <Redirect to="/app" />} />
      <Route path="/app/channels/:userId?" component={getPermission('/app/channels') ? Channels : () => <Redirect to="/app" />} />
      {/* <Redirect to="/app" /> */}
    </App>
  );
}

Dashboard.propTypes = {};

export default observer(Dashboard);
